<template>
  <div>
    <el-drawer
      :title="categoryName + '模板-已分配供应商列表'"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="80%"
      :before-close="handleClose"
    >
      <div class="facility-team-container">

        <el-table
          :data="supplierData"
          style="width: 100%"
          row-key="Id"
          height="calc(100vh - 120px)"
          v-loading="dataLoading"
          :tree-props="{ children: 'children' }"
        >
         <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cVenName"
            label="供应商名称"
            width="360"
            sortable
            show-overflow-tooltip
          />
          <el-table-column
            prop="SupplierClassificationName"
            label="供应商类型"
            width="120"
            sortable
            show-overflow-tooltip
          />
           <el-table-column
            prop="cVenPerson"
            label="联系人"
            width="150"
            sortable
            show-overflow-tooltip
          />
         <el-table-column
            prop="cVenPhone"
            label="联系电话"
            width="150"
            sortable
            show-overflow-tooltip
          />
         <el-table-column
            prop="EquipmentClassificationName"
            label="设备分类"
            width="350"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :disabled="!scope.row.EquipmentClassificationName || scope.row.EquipmentClassificationName.length <= 30"
              >
                <div slot="content" class="custom-tooltip-content">
                  <div
                    v-for="(item, index) in formatTooltipContent(scope.row.EquipmentClassificationName)"
                    :key="index"
                    class="tooltip-item"
                  >
                    <span class="tooltip-icon-square"></span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="ellipsis-cell">
                  {{ scope.row.EquipmentClassificationName || '-' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="SupplierQualificationName"
            label="项目资料类型"
            width="350"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :disabled="!scope.row.SupplierQualificationName || scope.row.SupplierQualificationName.length <= 30"
              >
                <div slot="content" class="custom-tooltip-content">
                  <div
                    v-for="(item, index) in formatTooltipContent(scope.row.SupplierQualificationName)"
                    :key="index"
                    class="tooltip-item"
                  >
                    <span class="tooltip-icon-square"></span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="ellipsis-cell">
                  {{ scope.row.SupplierQualificationName || '-' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="SupplierTypeName"
            label="资质资料类型"
            width="350"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :disabled="!scope.row.SupplierTypeName || scope.row.SupplierTypeName.length <= 30"
              >
                <div slot="content" class="custom-tooltip-content">
                  <div
                    v-for="(item, index) in formatTooltipContent(scope.row.SupplierTypeName)"
                    :key="index"
                    class="tooltip-item"
                  >
                    <span class="tooltip-icon-square"></span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="ellipsis-cell">
                  {{ scope.row.SupplierTypeName || '-' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="UserName"
            label="创建人"
            width="100"
            show-overflow-tooltip
            sortable
            fixed="right"
          />
          <el-table-column
            prop="CreateTime"
            label="创建时间"
            width="150"
            fixed="right"
          >
            <template slot-scope="scope">
              {{
                scope.row.CreateTime
                  ? moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="op" label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-share"
                size="mini"
                v-if="scope.row.Level == 1"
                @click="openTokenInfo(scope.row)"
                >邀请码</el-button
              >
              <!-- <el-button
                type="text"
                icon="el-icon-edit-outline"
                size="mini"
                style="color: #e6a23c"
                v-if="scope.row.Level == 1"
                @click="editItem(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                size="mini"
                style="color: red"
                v-if="scope.row.Level == 1"
                @click="delUser(scope.row)"
                >移除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <div style="height: 40px; margin-top: 10px">
          <el-button
            type="primary"
            size="mini"
            style="margin-right: 10px; float: right"
            @click="drawerVisible = false"
            >关闭</el-button
          >
        </div>
      </div>
    </el-drawer>
    <!-- 邀请码对话框 -->
    <el-dialog title="邀请码信息" :visible.sync="dialogVisible" width="600px">
      <div v-loading="shareTokenLoading">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="font-weight: bold; color: #000; font-size: 18px">
            点击红色链接复制
          </div>
          <div>
            <el-button type="primary" @click="getTokenInfo(1)"
              >重置邀请码</el-button
            >
          </div>
        </div>
        <div style="font-weight: bold; font-size: 16px; margin-top: 20px">
          邀请码信息：
        </div>
        <div
          style="margin-top: 10px; color: red; cursor: pointer"
          @click="copyTEXT(shareToken)"
        >
          {{ shareToken }}
        </div>
        <div style="margin-top: 20px; font-weight: bold; font-size: 16px">
          供应商填写资料地址：
        </div>
        <div
          style="margin-top: 10px; color: red; cursor: pointer"
          @click="copyTEXT(downloadUrl)"
        >
          {{ downloadUrl }}
        </div>
        <div style="margin-top: 20px; font-weight: bold; font-size: 16px">
          <el-button type="warning" @click="copyValue">复制邀请链接</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <PersonSelectStep
      ref="PersonSelectStep"
      :pId="projectId"
      @save="getSupplierList"
    ></PersonSelectStep>
  </div>
</template>

<script>
import tools from '@/utils/tools'
import { mapState } from 'vuex'
import moment from 'moment'
import PersonSelectStep from '@/views/Project/Page/TempSupplier/PersonSelectStep.vue'
export default {
  data() {
    return {
      moment,
      drawerVisible: false,
      DeviceTypeId: '', // 分类ID
      categoryName: '', // 分类名称
      projectId: '', // 项目ID
      supplierData: [], // 供应商数据
      dataLoading: false,

      // 邀请码相关
      shareTokenLoading: false,
      shareToken: '',
      downloadUrl: '',
      dialogVisible: false,

      item: {},
      DocumentList: [],
    }
  },
  components: {
    PersonSelectStep,
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    // 格式化 tooltip 内容，将逗号分隔的字符串转换为数组
    formatTooltipContent(text) {
      if (!text) return []
      return text.split(',').map(item => item.trim()).filter(item => item)
    },
    editItem(item) {
      this.$refs.PersonSelectStep.open('编辑供应商', item)
    },
    delUser(item) {
      this.$confirm('此操作将移除当前供应商,确认继续吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http
          .post(
            'Base_ProjectWork/Base_ProjectSupplier/DeleteProjectPartakeUserData',
            {
              UserId: '',
              SupplierId: item.Id,
              ProjectId: item.ProjectId,
            }
          )
          .then((res) => {
            if (res.Success) {
              this.getSupplierList()
              this.$notify.success('操作成功')
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    openDialog() {
      this.$refs.PersonSelectStep.open(
        '邀请供应商',
        null,
        false,
        this.DeviceTypeId
      )
    },
    // 打开抽屉
    open(DeviceTypeId, categoryName = '', projectId = '') {
      this.DeviceTypeId = DeviceTypeId
      this.categoryName = categoryName || '设备分类'
      this.projectId = projectId
      this.drawerVisible = true

      if (DeviceTypeId) {
        this.getSupplierList()
      }
    },

    // 关闭抽屉
    handleClose() {
      this.drawerVisible = false
      this.DeviceTypeId = ''
      this.categoryName = ''
      this.supplierData = []
    },

    // 获取供应商列表
    getSupplierList() {
      this.dataLoading = true
      this.$http
        .post(
          `/Base_ProjectWork/Base_ProjectSupplier/GetProjectTypeSupplierTree?ProjectId=${this.projectId}&DeviceType=${this.DeviceTypeId}`,
          {}
        )
        .then((res) => {
          this.dataLoading = false
          if (res.Success) {
            this.supplierData = res.Data || []
          } else {
            this.$notify.error(res.Msg || '获取供应商列表失败')
          }
        })
        .catch(() => {
          this.dataLoading = false
          this.$notify.error('获取供应商列表失败')
        })
    },

    // 导出Excel
    async getExcel() {
      if (!this.DeviceTypeId) {
        this.$notify.warning('请先选择设备分类')
        return
      }

      await tools.download(
        this.$rootUrl +
          `/Base_ProjectWork/Base_ProjectSupplier/ExportSupplierByCategoryToExcel?DeviceTypeId=${this.DeviceTypeId}&ProjectId=${this.projectId}`,
        `${this.categoryName}-供应商信息`,
        '.xlsx'
      )
    },

    // 格式化供应商名称
    formatName(row, column, cellValue) {
      if (row.Level == 1) {
        return row.cVenName
      } else if (row.Level == 2) {
        return row.cVenName ? row.cVenName + `（分包）` : ''
      }
      return cellValue
    },

    // 打开邀请码信息
    openTokenInfo(item) {
      this.item = item
      this.getTokenInfo()
    },

    // 获取邀请码信息
    getTokenInfo(isReset = '') {
      this.shareToken = ''
      this.downloadUrl = ''
      this.dialogVisible = true
      this.shareTokenLoading = true

      this.$http
        .post(
          `/Base_BasicData/Base_Supplier/SupGenerateToken?ProjectId=${this.item.ProjectId}&SupId=${this.item.Id}&Reset=${isReset}`
        )
        .then((res) => {
          this.shareTokenLoading = false
          if (res.Success) {
            this.shareToken = res.Data
          } else {
            this.dialogVisible = false
            this.$notify.error(res.Msg)
          }
        })

      this.downloadUrl =
        window.location.origin + '/TemplateLogin?ProjectId=' + this.projectId
    },

    // 复制邀请链接
    copyValue() {
      let text = `填写资料链接地址：${this.downloadUrl}   邀请码信息：${this.shareToken}  请复制链接后在浏览器中打开，即可填写资料`
      const t = document.createElement('textarea')
      t.nodeValue = text
      t.value = text
      document.body.appendChild(t)
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
      this.$notify.success('复制成功')
    },

    // 复制文本
    copyTEXT(text) {
      const t = document.createElement('textarea')
      t.nodeValue = text
      t.value = text
      document.body.appendChild(t)
      t.select()
      document.execCommand('copy')
      document.body.removeChild(t)
      this.$notify.success('复制成功')
    },

    // 打开URL
    openUrl(url) {
      window.open(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.facility-team-container {
  padding: 20px;
  height: 100%;
}

.supplier-card {
  height: 100%;

  ::v-deep .el-card__header {
    padding: 10px;
    border: none;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

::v-deep .el-descriptions-item__label {
  font-size: 16px;
  font-weight: bold;
  width: 20%;
}

::v-deep .el-descriptions-item__content {
  font-size: 14px;
}

::v-deep .el-drawer__header {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 0px;
}
/* 自定义 tooltip 内容样式 - 三列布局 */
.custom-tooltip-content {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 8px 16px;
  max-width: 600px;
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 4px;
  line-height: 1.8;
}

.tooltip-item {
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  line-height: 1.8;
  word-break: break-word;
  padding: 2px 4px;
  color: #fff;
}

.tooltip-icon-square {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #67c23a;
  margin-right: 8px;
  margin-top: 6px;
  flex-shrink: 0;
}

.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  cursor: default;
}
</style>
